import React, { useContext } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { Button } from '@rneui/themed';
import { FontAwesome6 } from '@expo/vector-icons';
import * as AddEventToCalendar from 'add-event-to-calendar';
import PropTypes from 'prop-types';
import { Alert } from '../../common/Alert';
import LayoutContext from '../../../contexts/Layout';

export const AddToCalendar = ({
    endDateAndTime,
    eventDescription,
    eventTitle,
    isAllDayEvent = false,
    maxRecurrenceDate,
    recurs = 0,
    recurrenceFrequencyDays,
    recurrenceMonthOptions,
    startDateAndTime,
    venueAddress
}) => {
    const { layout } = useContext(LayoutContext);

    const handlePress = () => {
        try {
            if (layout.device.os.equals('ios') || layout.device.os.equals('android')) {
                AddEventToCalendar.addEventAddedListener(result => {
                    Alert(`${result?.error ? 'Error\n' : 'Success\n'}${result?.message}`);
                });
            }

            AddEventToCalendar.addEvent({
                description: eventDescription,
                startDateAndTime,
                endDateAndTime,
                title: eventTitle,
                venueAddress,
                isAllDay: isAllDayEvent,
                isRecurring: recurs > 0,
                recurrence: recurs,
                recurrenceDays: recurrenceFrequencyDays || [],
                recurrenceMonthly: recurrenceMonthOptions || [],
                maxRecurrenceDate
            });
        } catch (error) {
            console.dir(error);
            Alert(`Error\n${error.message}`);
        }
    };
    3;
    return (
        <Button
            buttonStyle={Styles.button}
            icon={<FontAwesome6 color='#153d6e' name='calendar-alt' style={{ paddingLeft: 5 }} size={12} />}
            iconRight={true}
            onPress={handlePress}
            title='Add To Calendar'
            titleStyle={Styles.buttonTitle}
            type='outline'
        />
    );
};

const Styles = StyleSheet.create({
    button: {
        color: '#153d6e',
        borderColor: '#000',
        paddingVertical: 10
    },
    buttonTitle: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16
    }
});

AddToCalendar.propTypes = {
    endDateAndTime: PropTypes.string,
    eventDescription: PropTypes.string,
    eventTitle: PropTypes.string.isRequired,
    isAllDayEvent: PropTypes.bool,
    maxRecurrenceDate: PropTypes.string,
    recurs: PropTypes.number,
    recurrenceFrequencyDays: PropTypes.string,
    recurrenceMonthOptions: PropTypes.string,
    startDateAndTime: PropTypes.string.isRequired,
    venueAddress: PropTypes.string
};
